import React from "react";
import { Link } from "react-router-dom";
import { CONTACT_EMAIL, REGIONAL_CONTACT } from "../lib/copy";
import { useRegion } from "../Region";

export default function Footer() {
  const { region } = useRegion();
  const contact = REGIONAL_CONTACT[region];
  return (
    <footer className="footer" role="contentinfo">
      <div className="container footer-grid">
        <div className="footer-col">
          <div className="footer-title">Evon Polishing</div>
          <p className="muted">
            Restoration, polishing, and precious-metal plating for Catholic liturgical metalware.
          </p>
        </div>

        <div className="footer-col">
          <div className="footer-label">Explore</div>
          <Link to="/services">Services</Link>
          <Link to="/process">Process</Link>
          <Link to="/gallery">Gallery</Link>
          <Link to="/contact">Contact</Link>
        </div>

        <div className="footer-col">
          <div className="footer-label">Contact</div>
          {contact.phone && <a href={`tel:${contact.phone.replace(/[^+\d]/g, "")}`}>{contact.phone}</a>}
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          <span className="muted">{contact.location}</span>
        </div>
      </div>

      <div className="container footer-bottom">
        <span className="muted">© {new Date().getFullYear()} Evon Polishing. All rights reserved.</span>
      </div>
    </footer>
  );
}
